import React, { useState } from "react";
import Header from "../include/Header";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import CustomBreadcrumb from "../include/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config/api";

function Login() {

  // ===========================
  // 🧠 PAGE NAVIGATION
  // ===========================
  const navigate = useNavigate();

  // ===========================
  // 🧠 FORM STATE (EMAIL + PASSWORD)
  // ===========================
  const [formData, setFormData] = useState({
    email: "",     // user email
    password: "",  // user password
  });

  // ===========================
  // ✍️ INPUT CHANGE HANDLER
  // ===========================
  const handleChange = (e) => {

    setFormData({
      ...formData,                     // old data copy
      [e.target.name]: e.target.value // new value update
    });

  };

  // ===========================
  // 🚀 LOGIN FORM SUBMIT
  // ===========================
  const handleSubmit = async (e) => {

    e.preventDefault(); // page reload stop

    // try {

    //   // send login request to backend
    //   const res = await axios.post(
    //     "http://127.0.0.1:8000/api/login",
    //     formData
    //   );

    //   // ===========================
    //   // 💾 SAVE USER IN LOCAL STORAGE
    //   // ===========================
    //   localStorage.setItem(
    //     "user",
    //     JSON.stringify(res.data.user)
    //   );

    //   alert("Login Successful");

    //   // redirect to add product page
    //   navigate("/addproduct");

    // } catch (error) {

    //   console.log(error.response?.data);

    //   // show backend message OR fallback message
    //   alert(
    //     error.response?.data?.message ||
    //     "Invalid Email or Password"
    //   );
    // }


    try {

  const res = await axios.post(
    `${API_URL}/login`,
    formData
  );

  // ===========================
  // 💾 SAVE USER IN LOCAL STORAGE
  // ===========================
  localStorage.setItem(
    "user",
    JSON.stringify(res.data.user)
  );

  alert("Login Successful");

  // Redirect to add product page
  navigate("/addproduct");

} catch (err) {

  console.log(err);

  alert("Invalid Email or Password");

}
  };

  // ===========================
  // 🖥️ UI START
  // ===========================
  return (
    <>
      <Header />

      <div className="ved">

        <Container className="my-5">

          <CustomBreadcrumb title="Login" />

          <Row className="align-items-center shadow p-4 rounded bg-white">

            {/* ===========================
                🖼️ LEFT IMAGE SECTION
            =========================== */}
            <Col md={6}>

              <img
                src="https://picsum.photos/600/500"
                alt="Login"
                className="img-fluid rounded"
              />

            </Col>

            {/* ===========================
                🧾 RIGHT LOGIN FORM
            =========================== */}
            <Col md={6}>

              <div className="text-start">

                <h2 className="mb-4">
                  Login
                </h2>

                <Form onSubmit={handleSubmit}>

                  {/* EMAIL INPUT */}
                  <Form.Group className="mb-3">

                    <Form.Label>Email</Form.Label>

                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      required
                    />

                  </Form.Group>

                  {/* PASSWORD INPUT */}
                  <Form.Group className="mb-3">

                    <Form.Label>Password</Form.Label>

                    <Form.Control
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Enter your password"
                      required
                    />

                  </Form.Group>

                  {/* LOGIN BUTTON */}
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                  >
                    Login
                  </Button>

                  {/* REGISTER LINK */}
                  <p className="mt-3 text-center">

                    Don't have an account?{" "}

                    <Link to="/register">
                      Register
                    </Link>

                  </p>

                </Form>

              </div>

            </Col>

          </Row>

        </Container>

      </div>

    </>
  );
}

export default Login;